module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/img_webinar_06-4d9f105796ee7e84220ef75b9f2cb3c0.png";